{
  "view": {
    "title": "Säg upp avtalet",
    "rightOfOccupancyNoticeTitle": "Gör en överlåtelseanmälan",
    "description": "På denna sida kan du göra en elektronisk uppsägningsanmälan.",
    "rightOfOccupancyNoticeDescription": "På denna sida kan du göra en elektronisk överlåtelseanmälan.",
    "descriptionNewFeatures": "Säg upp hela avtalet, en enskild person eller meddela till exempel om en födelse.",
    "rightOfOccupancyNoticeDescriptionNewFeatures": "Gör en överlåtelseanmälan för hela avtalet eller en enskild person, eller meddela till exempel om en födelse."
  },
  "editView": {
    "title": "Avtalsändringar"
  },
  "headings": {
    "parties": "Parter",
    "terminateForm": "Uppsägningsblankett",
    "rentalTermination": "Uppsägning av hyresavtal",
    "rightOfOccupancyNotice": "Överlåtelseanmälan",
    "paymentAndContactInfo": "Betalnings- och kontaktuppgifter",
    "paymentInfo": "Betalningsuppgifter",
    "newAddress": "Ny adress",
    "showing": "Bostadsvisning",
    "additionalDetails": "Tilläggsuppgifter",
    "leavePreviewConfirmation": "Lämna formuläret?",
    "terminationPreview": "Förhandsgranskning av uppsägning",
    "rightOfOccupancyNoticePreview": "Förhandsgranskning av överlåtelseanmälan",
    "confirmation": "Granska avtalsanmälan",
    "basicInfo": "Grunduppgifter",
    "thankYou": "Tack",
    "confirmationRejected": "Uppsägningsanmälan har avvisats.",
    "rightOfOccupancyNoticeConfirmationRejected": "Överlåtelseanmälan har avvisats.",
    "contactInformation": "Kontaktuppgifter"
  },
  "labels": {
    "movingOutDate": "Utflyttningsdatum",
    "contractEndDate": "Avtalets slutdatum",
    "terminationReason": "Primär orsak till uppsägningen",
    "rightOfOccupancyNoticeReason": "Primär orsak till överlåtelseanmälan",
    "movingDestination": "Vart flyttar du",
    "files": "Bilagor",
    "beneficiaryName": "Kontoinnehavare",
    "iban": "Kontonummer",
    "bic": "BIC",
    "returnPercentage": "Återbetalningsbar andel av depositionen/återbetalningarna",
    "rooReturnPercentage": "Återbetalningsbar andel av bostadsrättsavgiften",
    "email": "E-post",
    "phoneNumber": "Telefon",
    "recipientName": "För- och efternamn",
    "streetAddress": "Gatuadress",
    "streetAddressLine2": "Gatuadress (rad 2)",
    "postalCode": "Postnummer",
    "city": "Postanstalt",
    "countryName": "Land",
    "countrySubdivision": "Region",
    "showing": "Bostadsvisning",
    "presenter": "Visare",
    "additionalDetails": "Tilläggsuppgifter",
    "givingContactInfoAllowed": "Mina kontaktuppgifter får ges vidare till dem som är intresserade av bostaden",
    "masterKeyAccessAllowed": "Jag ger tillåtelse att gå in i bostaden med huvudnyckel",
    "hasPetsInApartment": "Husdjur i bostad",
    "terminated": "Uppsagd",
    "rightOfOccupancyNoticeSubmitted": "Överlåtelseanmälan gjord",
    "rightOfOccupancyCollateralLocation": "Bostadsrättsavtal",
    "bank": "Bank"
  },
  "placeholders": {
    "additionalDetails": "Skriv tilläggsuppgifter om uppsägningen",
    "rightOfOccupancyNoticeAdditionalDetails": "Skriv tilläggsuppgifter om överlåtelseanmälan"
  },
  "alt": {
    "successIllustration": "Tack illustration"
  },
  "buttons": {
    "backToEdit": "Tillbaka till redigering",
    "continueFilling": "Ja",
    "leavePreview": "Nej",
    "confirmTermination": "Fortsätt till bekräftelse",
    "rejectTermination": "Avvisa uppsägningen",
    "confirmRightOfOccupancyNotice": "Bekräfta överlåtelseanmälan",
    "rejectRightOfOccupancyNotice": "Avvisa överlåtelseanmälan",
    "restart": "Börja på nytt",
    "back": "Tillbaka"
  },
  "texts": {
    "confirmationInstruction": "Granska de angivna uppgifterna och godkänn eller avvisa uppsägningen från din sida. Om uppgifterna behöver ändras, avvisa uppsägningen och fyll i uppsägningsformuläret på nytt.",
    "confirmationInstructionReview": "Kontrollera noggrant de uppgifter du har angett.",
    "confirmationInstructionConfirm": "Välj <strong>{{confirmButtonLabel}}</strong> och gå vidare till identifiering.",
    "confirmationInstructionEdit": "Om uppgifterna behöver ändras, välj <strong>{{backToEditButtonLabel}}</strong>.",
    "terminationNoticeSentAfterConfirmation": "Uppsägningsanmälan skickas först efter bekräftelsen.",
    "rightOfOccupancyNoticeSentAfterConfirmation": "Överlåtelseanmälan skickas först efter bekräftelsen.",
    "terminationNoticeBeforeConfirmationInstruction": "Granska uppgifterna i nästa steg och bekräfta uppsägningen genom att identifiera dig.",
    "leavePreviewConfirmation": "Du är på väg att lämna formuläret. Om du lämnar formuläret sparas inte de uppgifter du har fyllt i. Vill du fortsätta fylla i formuläret?",
    "additionalDetailsInfo": "Här kan du lämna tilläggsuppgifter om uppsägningen av avtalet. Du kan till exempel precisera uppgifter om bostadsvisning, återbetalning eller husdjur.",
    "rightOfOccupancyNoticeAdditionalDetailsInfo": "Här kan du lämna tilläggsuppgifter om överlåtelseanmälan för avtalet. Du kan till exempel precisera uppgifter om bostadsvisning, återbetalning eller husdjur.",
    "rightOfOccupancyNoticeBeforeConfirmationInstruction": "Granska uppgifterna i nästa steg och bekräfta överlåtelseanmälan genom att identifiera dig.",
    "movingOutDateTooltip": "Bostaden är tom och städad och nycklarna har återlämnats.",
    "contractEndDateTooltip": "Du kan vid behov ändra avtalets slutdatum till ett senare datum.",
    "terminationReasonTooltip": "Om det finns flera orsaker, välj den viktigaste.",
    "securityRestrictionWarning": "Du har ett giltigt sekretessförbud av säkerhetsskäl, så de adressuppgifter du anger visas inte för andra, inklusive andra parter i detta avtal.",
    "terminateInstructions": "Avtalets sista giltighetsdag är exakt 3 månader efter överlåtelseanmälan, dvs. tidigast {{endDate}}. Du kan välja en senare sista giltighetsdag vid behov.",
    "uploadFiles": "Lägg till bilagor genom att klicka eller dra\nMaximal storlek är 10 MB.",
    "addReceipts": "Om det har gjorts ändringsarbeten i bostaden och du inte har levererat oss kvittona gällande dem, bifoga dem här.",
    "paymentInfoReason": "Lägg till kontouppgifter för återbetalning av garantiavgiften och eventuella andra betalningar. De återbetalningsbara andelarna måste sammanlagt vara 100 %. Fyll i uppgifterna även om garantiavgiften inte återbetalas direkt till dig. Om återbetalningar görs till flera konton, välj Lägg till betalningsuppgifter och fyll i uppgifterna. Dela då återbetalningarna genom att ange procentandelen för varje återbetalning. Du kan ge ytterligare information om återbetalningar i fältet Tilläggsuppgifter i slutet av formuläret.",
    "paymentInfoReasonRental": "Lägg till kontouppgifter för återbetalning av garantiavgiften och eventuella andra betalningar. De återbetalningsbara andelarna måste sammanlagt vara 100 %. Fyll i uppgifterna även om garantiavgiften inte återbetalas direkt till dig. Om återbetalningar görs till flera konton, välj Lägg till betalningsuppgifter och fyll i uppgifterna. Dela då återbetalningarna genom att ange procentandelen för varje återbetalning. Du kan ge ytterligare information om återbetalningar i fältet Tilläggsuppgifter i slutet av formuläret.",
    "paymentInfoCollateralBankInstructions": "Lämna in bostadsrättsavtalet i pappersform till följande adress senast {{endDate}}:\n\n{{companyName}}\n{{companyAddress}}",
    "paymentInfoCollateralBankInstructionsNoAddress": "Lämna in bostadsrättsavtalet i pappersform till bostadsrättskontoret senast {{endDate}}.",
    "addPaymentInfo": "Lägg till betalningsuppgifterna",
    "newAddressReason": "Vi behöver din adress för att vid behov kunna skicka information och eventuella brev om avtalets upphörande. Om den nya adressen ännu inte är känd kan du lämna fältet tomt. Om det finns flera adresser, till exempel om man flyttar till olika adresser, kan du ge ytterligare information i fältet Tilläggsuppgifter i slutet av formuläret.",
    "showingInstructions": "Det enklaste är att komma överens om visningen direkt med dem som ska komma till bostadsvisningen. Om du inte vill att dina kontaktuppgifter ges vidare är det också möjligt att komma överens om bostadsvisningen via företag.",
    "showingInstructions2": "Om du väljer att företaget ska visa bostaden godkänner du också att bostaden kan besökas med huvudnyckel. Tidpunkten för visningen kommer att avtalas mellan parterna och den boende meddelas om visningen minst 24 timmar i förväg.",
    "selectedAsPresenter": "Du har valts att hålla visningen.",
    "terminationNotice": "Anmälan om uppsägning",
    "movingDestinationInstructions": "Lämna tom om du inte vet",
    "terminateInstructionsRental": "Avtalets sista giltighetsdag är den sista dagen i följande fulla kalendermånad, dvs. tidigast {{endDate}}. Du kan välja en senare sista giltighetsdag vid behov.",
    "monthEndDateUnavailable": "Det finns inga månadsslutsdatum inom det valda intervallet. Kontakta kundtjänsten.",
    "propertyCompanyName": "TA-Yhtymä Oy | TA-Asumisoikeus Oy",
    "propertyCompanyAddress": "Knitter Business Park\nVävarsvägen 6–8\n02630 Esbo",
    "propertyCompanyAddressError": "Ett fel uppstod när bostadsrättsavtalets leveransadress skulle hämtas.",
    "confirmationAccepted": "Uppsägningsanmälan har bekräftats för din del.",
    "rightOfOccupancyNoticeConfirmationAccepted": "Överlåtelseanmälan har bekräftats för din del.",
    "fixedTermAlert": "Observera att ett tidsbundet avtal i princip inte kan sägas upp. Du kan dock avsluta det i förtid t.ex. på grund av flytt till en annan ort eller sjukdom. Vänligen bifoga de nödvändiga bilagorna.",
    "terminationReturnFromAuthReminder": "Kom ihåg att uppsägningsanmälan skickas för behandling först när du har genomfört stark autentisering och återvänt till boendesidorna. Om autentiseringen avbryts förblir uppsägningen ofullständig.",
    "rightOfOccupancyNoticeReturnFromAuthReminder": "Kom ihåg att överlåtelseanmälan skickas för behandling först när du har genomfört stark autentisering och återvänt till boendesidorna. Om autentiseringen avbryts förblir överlåtelseanmälan ofullständig."
  },
  "terminateContractReasons": {
    "buyingProperty": "Jag har skaffat en ägarbostad",
    "moveToAnotherRental": "Jag flyttar till en hyresbostad",
    "moveToRightOfOccupancy": "Jag flyttar till en bostadsrättslägenhet",
    "moveToCareHomeOrHospital": "Jag flyttar till ett servicehem eller sjukhus",
    "moveDueWork": "Jag flyttar pga arbete eller studier",
    "moveToAnotherMunicipality": "Jag byter ort",
    "familySizeChange": "Förändring i familjens storlek (skilsmässa, äktenskap, samboförhållande, barn)",
    "apartmentSize": "Bostadens storlek",
    "poorApartmentCondition": "Bostadens dåliga skick",
    "poorApartmentEquipmentOrProperties": "Bostadens utrustning och/eller egenskaper",
    "poorPropertyCondition": "Fastighetens dåliga skick",
    "poorPropertyMaintenance": "Fastighetens dåliga skötsel",
    "housingCosts": "Boendekostnader",
    "disturbingNeighboursOrBuilding": "Störande grannar / störningar i huset",
    "areaPoorServices": "Dåliga tjänster i området",
    "poorTransportationOptions": "Dåliga trafikförbindelser",
    "moveToAnotherApartmentOfSameOwner": "Jag flyttar till en annan bostad av samma ägare",
    "death": "Dödsfall",
    "apartmentDoesNotMeetNeeds": "Bostaden motsvarar inte mina behov",
    "apartmentTemperature": "Bostadens temperatur",
    "apartmentLocation": "Bostadens läge",
    "studiesEnd": "Studierna avslutas",
    "rightOfOccupancyEnds": "Bostadsrätten upphör",
    "areaDisturbances": "Störningar i boendemiljön",
    "healthReasons": "Hälsoskäl",
    "eviction": "Vräkning",
    "renovation": "Grundrenovering / renovering",
    "businessClosure": "Företagsverksamheten upphör",
    "businessClosureInMunicipality": "Företagsverksamheten på orten upphör",
    "businessStructureChange": "Förändring i företagsstrukturen",
    "spaceNeedsChange": "Förändring i lokalbehovet",
    "moveToMoreAffordableBusinessPremisesInMunicipality": "Flytt till förmånligare lokaler på orten",
    "other": "Annan orsak",
    "unknown": "Okänt"
  },
  "terminationDestinations": {
    "buyingProperty": "Jag har skaffat en ägarbostad",
    "moveToAnotherApartmentOfSameOwner": "Jag flyttar till en annan hyresbostad hos samma ägare",
    "moveToAnotherRental": "Jag flyttar till en hyresbostad hos en annan aktör",
    "moveToRightOfOccupancyOfSameOwner": "Jag flyttar till en bostadsrättslägenhet hos samma ägare",
    "moveToRightOfOccupancyOfAnotherOperator": "Jag flyttar till en bostadsrättslägenhet hos en annan aktör",
    "moveToRightOfOccupancy": "Jag flyttar till en bostadsrättslägenhet",
    "moveToCareHomeOrHospital": "Jag flyttar till ett servicehem eller sjukhus",
    "other": "Annan orsak",
    "unknown": "Okänt"
  },
  "showingSuggestions": {
    "tenant": "Boende sköter bostadsvisningen",
    "propertyCompanyGroup": "Företag sköter bostadsvisningen"
  },
  "terminateSuggestions": {
    "terminate": "Säg upp",
    "rightOfOccupancyNotice": "Överlåtelseanmälan",
    "inEffect": "Giltig",
    "pending": "Väntar"
  },
  "rightOfOccupancyCollateralLocationSuggestions": {
    "bank": "Som säkerhet för lånet",
    "holder": "Av invånaren"
  },
  "terminationDisallowedReason": {
    "contractTerminated": "Avtalet har sagts upp.",
    "pendingTerminationTenantApprovals": "Avtalet sägs upp när uppsägningen har godkänts av en eller flera parter.",
    "rightOfOccupancyNoticePendingTenantApprovals": "Överlåtelseanmälan inväntar godkännande av en eller flera parter.",
    "pendingTerminationReview": "Uppsägningen av avtalet måste ännu godkännas.",
    "isEstateContract": "Avtalet är ett dödsbo.",
    "hasGuardianOfInterests": "Du kan inte säga upp bostaden elektroniskt eftersom en eller flera boende har fått en intressebevakare.",
    "missingResidentUsers": "Alla myndiga boende har inte användar-ID för boendesidorna.",
    "multipleContractParties": "Flera avtalsparter kan ännu inte säga upp avtalet på boendesidorna.",
    "contractTags": "Avtalet kan inte sägas upp elektroniskt. Vänligen kontakta kundtjänsten.",
    "notContractParty": "Du kan inte säga upp avtalet elektroniskt, eftersom du inte är en av avtalsparterna.",
    "tenantsWithUndeterminedAge": "Avtalet kan inte sägas upp elektroniskt eftersom vissa personuppgifter saknas. Vänligen kontakta kundtjänsten.",
    "hasCompanyTenant": "Avtal med företagspart kan inte sägas upp elektroniskt. Vänligen kontakta kundtjänsten.",
    "pendingModificationContract": "Avtalet har en öppen ändringsbegäran.",
    "pendingContractParty": "Du kan inte säga upp hyresavtalet elektroniskt innan avtalsändringarna träder i kraft.",
    "notStartedYet": "Avtalet har inte börjat ännu.",
    "openContinuationOffer": "Avtalet har ett öppet fortsättningserbjudande, och avtalsändringar kan inte göras från boendesidorna.",
    "pendingContractResign": "Avtalet väntar på att bli återundertecknat."
  },
  "confirmationError": {
    "noIdentityVerifier": "Användarens identitet kunde inte bekräftas",
    "noIdentity": "Användarens identitet kunde inte behandlas",
    "noUser": "Det uppstod ett fel när användarens uppgifter söktes",
    "noAttributes": "Användarens personuppgifter är bristfälliga",
    "identityMismatch": "Identiteten stämmer inte med den inloggade användaren",
    "initFailed": "Meddelandet om uppsägning kunde inte bekräftas",
    "cancelled": "Identifieringen återkallades",
    "addTenantInitFailed": "Det gick inte att lägga till boende",
    "movingOutDateNoLongerValid": "Utflyttningsdatumet är inte längre giltigt",
    "missingResidentCredentials": "Avtalet kan inte sägas upp för närvarande eftersom en eller flera avtalsparter eller betalare inte har inloggningsuppgifter till boendeappen.",
    "pendingTerminationRequest": "Ett meddelande om uppsägning har redan lämnats för avtalet, så ett nytt meddelande kan inte skickas."
  },
  "confirmationPendingText": "Identiteten har bekräftats: nu kan du säga upp avtalet.",
  "confirmTerminationButtonText": "Säg upp avtalet",
  "confirmationErrorText": "Det uppstod ett fel när meddelandet om uppsägning skulle skickas",
  "confirmErrorText": "Det uppstod ett fel när uppsägning skulle bekräftas",
  "confirmationBackButtonText": "Gå tillbaka",
  "confirmationClientError": {
    "nonceDiffFailed": "Det uppstod ett fel när blanketten skulle bekräftas",
    "formValuesMissing": "Uppgifterna i meddelandet om uppsägning fattas eller är felaktiga",
    "missingContractId": "Avtalsnumret är felaktigt eller fattas"
  },
  "confirmationState": {
    "confirmed": "Tack. Meddelandet om uppsägning har skickats. Du får ett automatiskt e-postmeddelande om att vi har tagit emot anmälan. Vi behandlar din anmälan så snart som möjligt. Om du inte får något meddelande, kontakta kundtjänsten.",
    "rightOfOccupancyNoticeConfirmed": "Tack. Överlåtelseanmälan har skickats. Du får ett automatiskt e-postmeddelande om att vi har tagit emot anmälan. Vi behandlar din anmälan så snart som möjligt. Om du inte får något meddelande, kontakta kundtjänsten.",
    "pending": "Meddelandet om uppsägning är skickat och väntar på ytterligare bekräftelse",
    "rightOfOccupancyNoticePending": "Överlåtelseanmälan är skickad och väntar på ytterligare bekräftelse",
    "rejected": "Meddelandet om uppsägning har återkallats",
    "rightOfOccupancyNoticeRejected": "Överlåtelseanmälan har återkallats",
    "notFound": "Inga uppgifter hittas med uppsägningsmeddelandets försändelsekod",
    "rightOfOccupancyNoticeNotFound": "Inga uppgifter hittas med överlåtelseanmälans försändelsekod",
    "loading": "Status om försändelsen av meddelandet om uppsägning laddas..."
  },
  "errors": {
    "outOfService": "Tyvärr kan avtalet inte sägas upp just nu. Var god och försök på nytt senare.",
    "tooEarlyToTerminate": "Avtalet kan sägas upp elektroniskt först efter att det trätt i kraft.",
    "tooEarlyToTerminateMessage": "Kontakta kundtjänsten vid behov.",
    "passportIdentityTerminateDisabled": "Uppsägning är inte möjlig ännu när du har identifierat dig med pass.",
    "passportIdentityTerminateDisabledMessage": "Kontakta kundtjänsten vid behov.",
    "terminationRequestUnavailable": "Uppsägningsmeddelandet kan inte visas just nu eftersom avtalsuppgifterna uppdateras."
  }
}
